export const FLUXO_SIDEBAR_STORAGE_KEY = 'dataflow.fluxo-sidebar.expanded';

/** Largura recolhida — igual Office e Factory */
export const FLUXO_SIDEBAR_WIDTH_COLLAPSED = 40;
/** Largura expandida — ícone + legenda */
export const FLUXO_SIDEBAR_WIDTH_EXPANDED = 128;

export function readFluxoSidebarExpanded(): boolean {
  try {
    return localStorage.getItem(FLUXO_SIDEBAR_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeFluxoSidebarExpanded(expanded: boolean): void {
  try {
    localStorage.setItem(FLUXO_SIDEBAR_STORAGE_KEY, expanded ? 'true' : 'false');
  } catch {
    // ignore quota / private mode
  }
}

export function getFluxoSidebarWidth(expanded: boolean): number {
  return expanded ? FLUXO_SIDEBAR_WIDTH_EXPANDED : FLUXO_SIDEBAR_WIDTH_COLLAPSED;
}
